import React from 'react';
import { Button } from '@/components/ui/button';

import type { ProgramControlCommonProps, SubmitReportFn } from '../controlTypes';

type ChargesManagerProgramControlsProps = ProgramControlCommonProps & {
  onSubmitReport: SubmitReportFn;
};

export const ChargesManagerProgramControls = ({
  actionRowClass,
  renderStandardActionButtons,
  renderReportActionLabel,
  onSubmitReport,
}: ChargesManagerProgramControlsProps) => (
  <div className="mb-3 rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-40)] bg-white px-4 py-3">
    <div className={actionRowClass}>
      {renderStandardActionButtons()}
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-8"
        onClick={() => onSubmitReport({ action: 'download-charges-report', download: '1' })}
      >
        {renderReportActionLabel('Download Charges Manager Report')}
      </Button>
    </div>
  </div>
);
